module.exports = __webpack_public_path__ + "static/img/pro-7-1-1.cd1e517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-1-1.png
// module id = VXYP
// module chunks = 0